<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    max-width="300"
    offset-y
  >
    <template v-slot:activator="{ props }">
      <div class="k-color-picker-input" v-bind="props">
        <label class="mr-1">{{ label }}</label>
        <div class="circle" :style="{ backgroundColor: value, color: textColor }"></div>
      </div>
    </template>

    <v-color-picker
      v-model="value"
      :mode="mode"
      :canvas-height="canvasHeight"
    ></v-color-picker>
  </v-menu>
</template>

<script>
  import { VColorPicker, VMenu } from "vuetify/components";

  export default {
    components: {
      VColorPicker,
      VMenu,
    },
    name: "ColorPicker",
    props: {
      modelValue: {
        type: String,
        required: true,
        default: "#000000",
      },
      label: {
        type: String,
        default: "",
      },
      mode: {
        type: String,
        default: "hex",
      },
      canvasHeight: {
        type: Number,
        default: 150,
      },
    },
    data() {
      return {
        menu: false,
      };
    },
    computed: {
      value: {
        get() {
          return this.modelValue;
        },
        set(newValue) {
          this.$emit("update:modelValue", newValue);
        },
      },
      textColor() {
        return this.isDarkColor(this.value) ? "#ffffff" : "#000000";
      },
    },
    methods: {
      isDarkColor(hexColor) {
        if (!hexColor || hexColor[0] !== "#" || hexColor.length !== 7) {
          return false;
        }

        const c = hexColor.substring(1);
        const rgb = parseInt(c, 16);
        const r = (rgb >> 16) & 0xff;
        const g = (rgb >> 8) & 0xff;
        const b = rgb & 0xff;
        const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
        return brightness < 186;
      },
    },
  };
</script>

<style>
  .w-100 {
    .k-color-picker-input {
      width: 100%;
      justify-content: space-between;
    }
  }

  .k-color-picker-input {
    border: 1px solid #dfdfdf;
    border-radius: 10px;
    padding: 6px 12px;
    display: inline-flex;
    position: relative;
    cursor: pointer;
    align-items: center;

    label {
      font-size: 14px;
    }

    .circle {
      width: 30px;
      height: 30px;
      border-radius: 100px;
      border: 1px solid #d0d0d0;
    }
  }

  .k-color-picker-input:hover {
    cursor: pointer;
    background-color: #f3f5f9;
  }
</style>
